import React from 'react';

interface PhoneNumberInputProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  label?: string;
  required?: boolean;
}

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
  value,
  onChange,
  error,
  label = 'Phone Number',
  required = false
}) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value.replace(/\D/g, ''); // Remove non-digit characters

    // Only allow up to 8 digits
    if (input.length <= 8) {
      onChange(input);
    }
  };

  const isValid = value.length === 8 && /^[67]/.test(value); // starts with 6 or 7 and has 8 digits

  return (
    <div className="w-full">
      <label htmlFor="phoneNumber" className="block text-sm font-medium text-gray-700 mb-1">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <div className="flex items-center border border-gray-300 rounded-md overflow-hidden focus-within:ring-2 focus-within:ring-blue-500">
        <span className="px-3 bg-gray-100 text-gray-700 text-sm whitespace-nowrap">+268</span>
        <input
          type="tel"
          id="phoneNumber"
          inputMode="numeric"
          pattern="[0-9]*"
          value={value}
          onChange={handleInputChange}
          className="flex-1 px-3 py-2 outline-none focus:ring-0 text-gray-800"
          placeholder="7xxx xxxx"
          required={required}
          aria-invalid={!isValid && value !== ''}
        />
      </div>
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
      {!error && value !== '' && !isValid && (
        <p className="mt-1 text-sm text-yellow-600">Must be 8 digits and start with 6 or 7</p>
      )}
    </div>
  );
};

export default PhoneNumberInput;

